import React, {useState, Fragment, useEffect} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import './TableTeachers.scss'
import {
  defaultPaginationOptions,
  defaultTableHeaderStyles,
} from "root/School/BaseTableComponents";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle} from "root/Tables/BaseTableComponents";

const TableAttendanceOfficers= (props) =>
{
  const onClickEdit = ( school_id ) =>
  {
    props.clickHandler (school_id, 'edit', props.onDialogClosed );
  }

  const statusFormatter = (cell, row, rowIndex, formatExtraData) => {
    if ( row.school_attendance_officer_id === null )
    {
      return (
          <span/>
      );
    }
    else
    {
      return (
          <span style={{color: 'var(--s360-icon-red'}}>CURRENT</span>
      )
    }
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    surname: {borderRadius: defaultTopLeftCellStyle, width: "18vw"},
    school_attendance_officer_id: {borderRadius: defaultTopRightCellStyle, textAlign: 'left', width: "10vw"}
  });

  const getColumns = () => {
    const columns = [
      {
        dataField: "firstname",
        text: "First Name",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "surname",
        text: "Surname",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "email",
        text: "Email Address",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "school_attendance_officer_id",
        text: "Status",
        align: 'left',
        formatter: statusFormatter,
        headerStyle: headerStyle
      },
      /* {
        dataField: "view",
        text: "",
        formatter: linkFormatter,
        headerStyle: leftHeaderStyle
      } */
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());

  const columns = React.useMemo(() => translations, []);

  const tableContent = () =>
  {
    return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>

  }

  return props.loading === true ? <SpinnerDiv/> : tableContent();
};

export default TableAttendanceOfficers;
